var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = '../../../../../../../public/pdf.worker.min.js';
import { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import DropdownIcon from '@assets/svg/dropDownIcon.svg';
import CenterModal from '@/components/CenterModal/CenterModal';
import Loader from '@/components/Loader/Loader';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import WordIcon from '@assets/svg/wordIcon.svg';
import PdfIcon from '@assets/svg/pdfIcon.svg';
import { Document, Page } from 'react-pdf';
var MenuItem = function (_a) {
    var menu = _a.menu, handleDelete = _a.handleDelete, isLoading = _a.isLoading, menuThumbnails = _a.menuThumbnails, index = _a.index;
    var _b = useState({
        modalIsOpen: false,
        centerModalShow: false,
        imageToShow: '',
        isDeleting: false // New state to track if delete action has been initiated
    }), state = _b[0], setState = _b[1];
    var _c = useState(0), numPages = _c[0], setNumPages = _c[1];
    var _d = useState(1), pageNumber = _d[0], setPageNumber = _d[1];
    var _e = useState(null), pdfBlobUrl = _e[0], setPdfBlobUrl = _e[1];
    useEffect(function () {
        var fetchPdf = function () {
            return __awaiter(void 0, void 0, void 0, function () {
                var type, response, blob, url, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            type = getFileType(state.imageToShow);
                            if (!(type === "pdf"))
                                return [3 /*break*/, 6];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, fetch(state.imageToShow, { mode: 'cors' })];
                        case 2:
                            response = _a.sent();
                            return [4 /*yield*/, response.blob()];
                        case 3:
                            blob = _a.sent();
                            url = URL.createObjectURL(blob);
                            setPdfBlobUrl(url);
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _a.sent();
                            console.error("Error loading PDF:", err_1);
                            return [3 /*break*/, 5];
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            setPdfBlobUrl(null);
                            _a.label = 7;
                        case 7: return [2 /*return*/];
                    }
                });
            });
        };
        if (state.centerModalShow) {
            fetchPdf();
        }
        return function () {
            if (pdfBlobUrl) {
                URL.revokeObjectURL(pdfBlobUrl);
                setPdfBlobUrl(null);
            }
        };
    }, [state.imageToShow, state.centerModalShow]);
    var getFileType = function (url) {
        var _a;
        if (typeof url !== 'string')
            return "unknown";
        var extension = (_a = url.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!extension)
            return "unknown";
        if (["jpg", "jpeg", "png", "gif", "webp", 'jfif'].includes(extension))
            return "image";
        if (["pdf"].includes(extension))
            return "pdf";
        if (["doc", "docx"].includes(extension))
            return "doc";
        return "unknown";
    };
    console.log(state.imageToShow, 'imageToShowimageToShowimageToShowimageToShow');
    var handleIconClick = useCallback(function (e) {
        e.stopPropagation();
        setState(function (prevState) { return (__assign(__assign({}, prevState), { modalIsOpen: !prevState.modalIsOpen })); });
    }, []);
    var handleModalClick = useCallback(function (e) {
        e.stopPropagation();
        setState(function (prevState) {
            var _a, _b;
            return (__assign(__assign({}, prevState), { centerModalShow: true, imageToShow: (_b = (_a = menuThumbnails === null || menuThumbnails === void 0 ? void 0 : menuThumbnails.props) === null || _a === void 0 ? void 0 : _a.src) !== null && _b !== void 0 ? _b : menuThumbnails, isDeleting: false }));
        });
    }, [menuThumbnails]);
    var handleDeleteClick = useCallback(function (e) {
        e.stopPropagation();
        setState(function (prevState) {
            var _a, _b;
            return (__assign(__assign({}, prevState), { centerModalShow: true, imageToShow: (_b = (_a = menuThumbnails === null || menuThumbnails === void 0 ? void 0 : menuThumbnails.props) === null || _a === void 0 ? void 0 : _a.src) !== null && _b !== void 0 ? _b : '', isDeleting: true // здесь должно быть true!
            }));
        });
    }, [menuThumbnails]);
    var handleClose = useCallback(function () {
        setState({ modalIsOpen: false, centerModalShow: false, imageToShow: '', isDeleting: false });
    }, []);
    var handleDeletePress = useCallback(function (e) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.stopPropagation();
                        setState(function (prevState) { return (__assign(__assign({}, prevState), { isDeleting: true })); }); // Set isDeleting to true before delete action
                        return [4 /*yield*/, handleDelete()];
                    case 1:
                        _a.sent();
                        handleClose();
                        return [2 /*return*/];
                }
            });
        });
    }, [handleDelete, handleClose]);
    var onDocumentLoadSuccess = function (_a) {
        var numPages = _a.numPages;
        setNumPages(numPages);
    };
    var onNextPage = function () {
        if (pageNumber < numPages)
            setPageNumber(pageNumber + 1);
    };
    var onPrevPage = function () {
        if (pageNumber > 1)
            setPageNumber(pageNumber - 1);
    };
    var getFileExtension = function (url) {
        var _a;
        var match = (_a = url.split('.').pop()) === null || _a === void 0 ? void 0 : _a.split(/\#|\?/)[0];
        return match ? match.toLowerCase() : '';
    };
    var handleDownload = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var fileUrl, extension, response, blob, url, link, filename, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        fileUrl = state.imageToShow;
                        extension = getFileExtension(fileUrl);
                        return [4 /*yield*/, fetch(fileUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.blob()];
                    case 2:
                        blob = _a.sent();
                        url = window.URL.createObjectURL(blob);
                        link = document.createElement("a");
                        link.href = url;
                        filename = 'document';
                        if (extension) {
                            filename += ".".concat(extension);
                        }
                        else {
                            filename += '.file'; // fallback
                        }
                        link.setAttribute("download", filename);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error downloading the file:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    console.log(menuThumbnails, 'menuThumbnails');
    function isSupportedFileType(url) {
        var _a;
        if (typeof url !== 'string')
            return false;
        var extension = (_a = url.split('.').pop()) === null || _a === void 0 ? void 0 : _a.split('?')[0].split('#')[0].toLowerCase();
        return ['doc', 'docx', 'pdf'].includes(extension !== null && extension !== void 0 ? extension : '');
    }
    function fileType(url) {
        var _a;
        if (!url)
            return false;
        var extension = (_a = url.split('.').pop()) === null || _a === void 0 ? void 0 : _a.split('?')[0].split('#')[0].toLowerCase();
        return extension;
    }
    console.log(state, '1111111111');
    return (_jsxs(ArrayItem, { children: [_jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20vw' } }, { children: [!isSupportedFileType(menuThumbnails) ?
                        _jsx(PhotoPreviewContainer, __assign({ onClick: handleModalClick }, { children: (menuThumbnails === null || menuThumbnails === void 0 ? void 0 : menuThumbnails.props) ? menuThumbnails : (menuThumbnails ? _jsx("img", { src: menuThumbnails, alt: "Page Preview" }) : _jsx("div", { children: "No preview available" })) }))
                        :
                            _jsx(PhotoPreviewContainer, __assign({ onClick: handleModalClick, style: { marginLeft: '10px' } }, { children: fileType(menuThumbnails) === 'pdf' ?
                                    _jsx(PdfIcon, { width: 190 }) :
                                    _jsx(WordIcon, { width: 190 }) })), _jsx("p", { children: menu.fileName })] })), _jsx(IconContainer, __assign({ isShow: state.modalIsOpen, onClick: handleIconClick }, { children: _jsx(DropdownIcon, {}) })), _jsx(Modal, __assign({ isShow: state.modalIsOpen, onClick: handleDeleteClick }, { children: _jsx("span", __assign({ style: modalTextStyle }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) })), _jsx(CenterModal, __assign({ show: state.centerModalShow, handleClose: handleClose, customContStyle: { overflow: getFileType(state.imageToShow) == "pdf" ? 'scroll' : 'auto' }, customStyle: {
                    minHeight: getFileType(state.imageToShow) == "doc" && "13vh",
                    maxWidth: getFileType(state.imageToShow) == "pdf" && "fit-content",
                    marginTop: getFileType(state.imageToShow) == "pdf" && "1vh"
                } }, { children: !state.isDeleting && state.imageToShow ? ((function () {
                    var fileType = getFileType(state.imageToShow);
                    if (fileType === "image") {
                        return _jsx("img", { src: state === null || state === void 0 ? void 0 : state.imageToShow, alt: "Preview", style: { maxWidth: '100%', maxHeight: '100%' } });
                    }
                    else if (fileType === "pdf") {
                        return (_jsxs("div", __assign({ style: { width: "100%" } }, { children: [_jsx(Document, __assign({ file: pdfBlobUrl, onLoadError: function (error) { return console.error('PDF Error:', error); }, loading: _jsx("div", { children: "Loading PDF..." }), noData: _jsx("div", { children: "No PDF data" }), error: _jsx("div", { children: "Error loading PDF" }), onLoadSuccess: onDocumentLoadSuccess }, { children: _jsx(Page, { pageNumber: pageNumber }) })), _jsxs("div", __assign({ style: { width: '100%', justifyContent: 'center', gap: '10px', display: 'flex' } }, { children: [_jsx("button", __assign({ onClick: onPrevPage, style: {
                                                padding: '10px',
                                                fontSize: '14px',
                                                cursor: 'pointer',
                                                border: 'none'
                                            } }, { children: "<" })), _jsx("button", __assign({ onClick: onNextPage, style: {
                                                padding: '10px',
                                                fontSize: '14px',
                                                cursor: 'pointer',
                                                border: 'none'
                                            } }, { children: ">" }))] })), _jsxs("div", __assign({ style: { width: '100%', marginTop: '10px', justifyContent: 'space-around', display: 'flex', alignItems: 'center' } }, { children: [_jsxs("p", __assign({ style: { textAlign: 'center' } }, { children: ["Page ", pageNumber, " / ", numPages] })), _jsx("span", __assign({ onClick: handleDownload }, { children: "Download" }))] }))] })));
                    }
                    else if (fileType === "doc") {
                        return (_jsxs("div", { children: [_jsx("p", { children: "Click to download" }), _jsx("button", __assign({ style: {
                                        borderRadius: 5,
                                        padding: '10px',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        border: 'none',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                    }, onClick: handleDownload }, { children: "Download" }))] }));
                    }
                    else {
                        return _jsx("div", { children: "Unsupported file type" });
                    }
                })()) : (_jsxs("div", { children: [_jsx("p", __assign({ style: modalTitleStyle }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C?" })), _jsx("p", __assign({ style: modalDescStyle }, { children: "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0444\u0430\u0439\u043B?" })), _jsxs(ButtonContainer, { children: [_jsx(Button, __assign({ onClick: handleDeletePress }, { children: isLoading ? _jsx(Loader, { width: '20px', height: '20px' }) : _jsx("span", __assign({ style: buttonTextStyle }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) })), _jsx("span", __assign({ onClick: handleClose, style: cancelTextStyle }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" }))] })] })) }))] }, menu.id));
};
var modalTextStyle = {
    color: '#EB5757',
    fontFamily: 'Montserrat Regular',
    fontWeight: 400,
    fontSize: '16px',
    cursor: 'pointer',
};
var modalTitleStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 500,
    fontSize: '20px',
};
var modalDescStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 400,
    fontSize: '14px',
    marginBottom: '40px',
};
var buttonTextStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 500,
    fontSize: '16px',
};
var cancelTextStyle = {
    fontFamily: 'Montserrat Regular',
    fontWeight: 500,
    fontSize: '16px',
    marginLeft: '40px',
    cursor: 'pointer',
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n     position: relative;\n    display: flex;\n    align-items: center;\n    padding: 0 4vw;\n    padding-left: 1vw;\n    height: 116px;\n    background: #fff;\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-bottom: ", ";\n    @media (max-width: 768px) {\n        flex-direction: column;\n        height: auto;\n        padding: 2vw;\n    }\n"], ["\n     position: relative;\n    display: flex;\n    align-items: center;\n    padding: 0 4vw;\n    padding-left: 1vw;\n    height: 116px;\n    background: #fff;\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-bottom: ", ";\n    @media (max-width: 768px) {\n        flex-direction: column;\n        height: auto;\n        padding: 2vw;\n    }\n"])), function (props) { return (props.isFirst ? '8px' : '0'); }, function (props) { return (props.isFirst ? '8px' : '0'); }, function (props) { return (props.isLast ? '8px' : '0'); }, function (props) { return (props.isLast ? '8px' : '0'); }, function (props) { return (props.isLast ? 'none' : '1px solid #E3E3E3'); });
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: auto;\n    width: 32px;\n    display: flex;\n    height: 32px;\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    margin-right: 46px;\n    border-radius: 50%;\n    cursor: pointer;\n"], ["\n    margin-left: auto;\n    width: 32px;\n    display: flex;\n    height: 32px;\n    background: ", ";\n    align-items: center;\n    justify-content: center;\n    margin-right: 46px;\n    border-radius: 50%;\n    cursor: pointer;\n"])), function (props) { return (props.isShow ? '#E2E2E2' : 'none'); });
var Modal = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    right: 4vw;\n    top: 80px;\n    background-color: #fff;\n    border: 1px solid #E3E3E3;\n    border-radius: 8px;\n    display: ", ";\n    z-index: 2;\n    padding: 16px;\n    box-shadow: 0px 4px 4px 0px #0000001A;\n"], ["\n    position: absolute;\n    right: 4vw;\n    top: 80px;\n    background-color: #fff;\n    border: 1px solid #E3E3E3;\n    border-radius: 8px;\n    display: ", ";\n    z-index: 2;\n    padding: 16px;\n    box-shadow: 0px 4px 4px 0px #0000001A;\n"])), function (props) { return (props.isShow ? 'block' : 'none'); });
var ButtonContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    margin: 10px 0;\n    align-items: center;\n    justify-content: center;\n"], ["\n    display: flex;\n    margin: 10px 0;\n    align-items: center;\n    justify-content: center;\n"])));
var Button = styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: block;\n    padding: 15px 15px;\n    background-color: #EB5757;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: #f34040;\n    }\n"], ["\n    display: block;\n    padding: 15px 15px;\n    background-color: #EB5757;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n\n    &:hover {\n        background-color: #f34040;\n    }\n"])));
var ArrayItem = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\ncursor: pointer;\n     position: relative;\n     flex-direction: row;\n     text-align: center;\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    height: 116px;\n    width: 100%;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n"], ["\ncursor: pointer;\n     position: relative;\n     flex-direction: row;\n     text-align: center;\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    height: 116px;\n    width: 100%;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n"])));
var PhotoPreviewContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    img {\n        object-fit: cover;\n        max-width: 200px;\n        max-height: 108px;\n        border-radius: 8px;\n    }\n"], ["\n    img {\n        object-fit: cover;\n        max-width: 200px;\n        max-height: 108px;\n        border-radius: 8px;\n    }\n"])));
var ItemText = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    color: #000000;\n    align-self: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &:first-child {\n        flex: 0 0 20vw;\n        @media (max-width: 768px) {\n            flex: 0 0 auto;\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n\n    &:nth-child(2) {\n        flex: 1;\n        @media (max-width: 768px) {\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n"], ["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    color: #000000;\n    align-self: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &:first-child {\n        flex: 0 0 20vw;\n        @media (max-width: 768px) {\n            flex: 0 0 auto;\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n\n    &:nth-child(2) {\n        flex: 1;\n        @media (max-width: 768px) {\n            width: 100%;\n            margin-bottom: 10px;\n        }\n    }\n"])));
export default MenuItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
